const schemeMenuItems = [
  {
    id: "nmdfc-schemes",
    label: "NMDFC Schemes",
    path: "/schemes/nmdfc-schemes",
  },
  {
    id: "term-loan-scheme",
    label: "Term Loan Scheme",
    path: "/schemes/term-loan-scheme",
  },
  {
    id: "education-loan-scheme",
    label: "Education Loan Scheme",
    path: "/schemes/education-loan-scheme",
  },
  {
    id: "micro-finance-scheme",
    label: "Micro-Finance Scheme",
    path: "/schemes/micro-finance-scheme",
  },
  {
    id: "virasat-scheme",
    label: "Virasat Scheme",
    path: "/schemes/virasat-scheme",
  },
  {
    id: "promotional-schemes",
    label: "Promotional Schemes",
    path: "/schemes/promotional-schemes",
  },
  {
    id: "maulana-azad-national-fellowship-scheme",
    label: "Maulana Azad National Fellowship Scheme",
    path: "/schemes/maulana-azad-national-fellowship-scheme",
  },
  {
    id: "refinancing-through-banks",
    label: "Refinance and Channelising Agencies",
    path: "/schemes/refinancing-through-banks",
  },
];

export const normalizeSchemeSection = (section) => {
  const matchedSection = schemeMenuItems.find((item) => item.id === section);
  return matchedSection ? matchedSection.id : schemeMenuItems[0].id;
};

export default schemeMenuItems;
